import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type UploadProgressDialogProps = {
  activeStepIndex: number;
  steps: string[];
};

/** Renders a dialog with a MUI Stepper while an upload job is processing in the background */
const UploadProgressDialog = ({ activeStepIndex, steps }: UploadProgressDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={activeStepIndex >= 0} disableEscapeKeyDown>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={20} />
          <Typography>{steps[activeStepIndex] ?? `${t("Common.Uploading")}...`}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stepper activeStep={activeStepIndex} alternativeLabel sx={{ minWidth: 480 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </DialogContent>
    </Dialog>
  );
};

export default UploadProgressDialog;
